<h3>Contratos</h3>

<mat-nav-list *ngIf="(isMobile | async).matches">
  <div>
    <mat-accordion>
      <mat-expansion-panel *ngFor="let contrato of contratos">
        <mat-expansion-panel-header>
          <mat-panel-title class="contrato-tile">
            Contrato: &nbsp; {{contrato.contrato}}
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="content">
          <p>Mercadoria:
            <mat-list>
              <span class="mercadoria-list-item" *ngFor="let mercadoria of contrato?.mercadoria?.mercadorias">
                {{mercadoria}}<br />
              </span>
            </mat-list>
          </p>
          <p>Data de Vencimento: {{contrato?.vencimento | date:'dd/MM/yyyy'}}</p>
          <p>Saldo: {{contrato?.saldo | currency:'BRL'}}</p>
          <p>Plano: {{obterPlano(contrato)}}</p>
          <p>Parcelas Pagas: {{contrato?.quantidadeParcelasPagas}}</p>
          <p>Situação: {{contrato?.situacao | situacaoContrato}}</p>
          <div class="expasion-button expansions-actions">
            <button mat-raised-button (click)="selecionarContratoParaSegundaVia(contrato)" color="primary">
              {{contrato.funcionarioFolhaPagamento ? 'Ver Parcelas' : 'Gerar 2ª Via'}}
            </button>

            <button
              mat-raised-button
              color="primary"
              (click)="selecionarContratoParaRenegocicao(contrato)"
              *ngIf="contrato.renegociavel && !contrato.funcionarioFolhaPagamento">
              Renegociar
            </button>
            <button 
              mat-raised-button 
              color="primary"
              (click)="exibirPropostasOutrosCanais(contrato)"
              *ngIf="temColaboradorAutenticado && !contrato.funcionarioFolhaPagamento">
              Outras Propostas
            </button>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</mat-nav-list>

<table mat-table *ngIf="!(isMobile | async).matches" [dataSource]="contratos" class="mat-elevation-z2 table">
  <ng-container matColumnDef="contrato">
    <th mat-header-cell *matHeaderCellDef>Contrato</th>
    <td mat-cell *matCellDef="let contrato">{{contrato?.contrato}}</td>
  </ng-container>
  
  <ng-container matColumnDef="mercadoria">
    <th mat-header-cell *matHeaderCellDef>Mercadoria</th>
    <td mat-cell *matCellDef="let contrato">
      <span class="mercadoria-table-item" *ngFor="let mercadoria of contrato?.mercadoria?.mercadorias">
        {{mercadoria}}<br />
      </span>
    </td>
  </ng-container>
  
  <ng-container matColumnDef="dataVencimento">
    <th mat-header-cell *matHeaderCellDef>Data de Vencimento</th>
    <td mat-cell *matCellDef="let contrato">{{contrato?.vencimento | date:'dd/MM/yyyy'}}</td>
  </ng-container>
  
  <ng-container matColumnDef="saldo">
    <th mat-header-cell *matHeaderCellDef>Saldo</th>
    <td mat-cell *matCellDef="let contrato">{{contrato?.saldo | currency:'BRL'}}</td>
  </ng-container>
  
  <ng-container matColumnDef="plano">
    <th mat-header-cell *matHeaderCellDef>Plano</th>
    <td mat-cell *matCellDef="let contrato">{{obterPlano(contrato)}}</td>
  </ng-container>
  
  <ng-container matColumnDef="parcelasPagas">
    <th mat-header-cell *matHeaderCellDef>Parcelas Pagas</th>
    <td mat-cell *matCellDef="let contrato">{{contrato?.quantidadeParcelasPagas}}</td>
  </ng-container>

  <ng-container matColumnDef="situacao">
    <th mat-header-cell *matHeaderCellDef>Situação</th>
    <td mat-cell *matCellDef="let contrato">{{contrato?.situacao | situacaoContrato}}</td>
  </ng-container>

  <ng-container matColumnDef="actions">
    <th class="text-right" mat-header-cell *matHeaderCellDef></th>
    <td class="text-right table-actions" mat-cell *matCellDef="let contrato">
      <div>
        <button 
          mat-raised-button 
          color="primary"
          (click)="selecionarContratoParaSegundaVia(contrato)">
          {{contrato.funcionarioFolhaPagamento ? 'Ver Parcelas' : 'Gerar 2ª Via'}}
        </button>
        <button 
          mat-raised-button 
          color="primary"
          (click)="selecionarContratoParaRenegocicao(contrato)"
          *ngIf="contrato.renegociavel  && !contrato.funcionarioFolhaPagamento">
          Renegociar
        </button>
      </div>
      <button 
        mat-raised-button 
        color="primary"
        class="btn-outras-propostas"
        (click)="exibirPropostasOutrosCanais(contrato)"
        *ngIf="temColaboradorAutenticado  && !contrato.funcionarioFolhaPagamento">
        Outras Propostas
      </button>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="['contrato', 'mercadoria', 'dataVencimento', 'saldo', 'plano', 'parcelasPagas', 'situacao', 'actions']"></tr>
  <tr mat-row *matRowDef="let row; columns: ['contrato', 'mercadoria', 'dataVencimento', 'saldo', 'plano', 'parcelasPagas', 'situacao', 'actions'];"></tr>
</table>

<div *ngIf="contratosVendidos?.length > 0" class="contratos-vendidos">
  <div class="alert" role="alert">
    <div class="alert-icon">
      <mat-icon>
        info
      </mat-icon>
    </div>
    <div class="alert-message">
      Comunicamos que o(s) contrato(s) abaixo não estão mais em poder {{ bandeira === Bandeira.CASAS_BAHIA ? 'da Casas Bahia': 'do Pontofrio' }}. 
      Por gentileza realizar a renegociação com a empresa indicada.
    </div>
  </div>

  <mat-nav-list *ngIf="(isMobile | async).matches">
    <div>
      <mat-accordion>
        <mat-expansion-panel *ngFor="let contratoVendido of contratosVendidos">
          <mat-expansion-panel-header>
            <mat-panel-title class="contrato-tile">
              Contrato: &nbsp; {{contratoVendido.contrato}}
            </mat-panel-title>
          </mat-expansion-panel-header>
  
          <div class="content">
            <p>Data: {{contratoVendido.data | date:'dd/MM/yyyy'}}</p>
            <p>Empresa: {{contratoVendido.razaoSocial}}</p>
            <p>Telefone: {{contratoVendido.telefone}}</p>
            <p>Valor: {{contratoVendido.valor | currency:'BRL'}}</p>
            <p>
              Site: 
              <a class="link" href="{{contratoVendido?.site}}" target="_blank">
                {{contratoVendido?.site}}
              </a> 
            </p>
            <p>
              Whatsapp: 
              <a class="link" href="https://api.whatsapp.com/send?1=pt_BR&phone={{contratoVendido?.whatsapp}}" target="_blank">
                {{contratoVendido?.whatsapp}}
              </a> 
            </p>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </mat-nav-list>
  
  <table mat-table *ngIf="!(isMobile | async).matches" [dataSource]="contratosVendidos" class="mat-elevation-z2 table">
    <ng-container matColumnDef="contrato">
      <th mat-header-cell *matHeaderCellDef>Contrato</th>
      <td mat-cell *matCellDef="let contratoVendido">{{contratoVendido?.contrato}}</td>
    </ng-container>
  
    <ng-container matColumnDef="data">
      <th mat-header-cell *matHeaderCellDef>Data</th>
      <td mat-cell *matCellDef="let contratoVendido">{{contratoVendido.data | date:'dd/MM/yyyy'}}</td>
    </ng-container>
    
    <ng-container matColumnDef="razaoSocial">
      <th mat-header-cell *matHeaderCellDef>Empresa</th>
      <td mat-cell *matCellDef="let contratoVendido">{{contratoVendido?.razaoSocial}}</td>
    </ng-container>
    
    <ng-container matColumnDef="telefone">
      <th mat-header-cell *matHeaderCellDef>Telefone</th>
      <td mat-cell *matCellDef="let contratoVendido">{{contratoVendido.telefone}}</td>
    </ng-container>
    
    <ng-container matColumnDef="valor">
      <th mat-header-cell *matHeaderCellDef>Valor</th>
      <td mat-cell *matCellDef="let contratoVendido">{{contratoVendido?.valor | currency:'BRL'}}</td>
    </ng-container>
    
    <ng-container matColumnDef="site">
      <th mat-header-cell *matHeaderCellDef>Site</th>
      <td mat-cell *matCellDef="let contratoVendido">
        <a href="{{contratoVendido?.site}}" target="_blank">
          {{contratoVendido?.site}}
        </a> 
      </td>
    </ng-container>
    
    <ng-container matColumnDef="whatsapp">
      <th mat-header-cell *matHeaderCellDef>Whatsapp</th>
      <td mat-cell *matCellDef="let contratoVendido">
        <a href="https://api.whatsapp.com/send?1=pt_BR&phone={{contratoVendido?.whatsapp}}" target="_blank">
          {{contratoVendido?.whatsapp}}
        </a> 
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="['contrato', 'valor', 'data', 'razaoSocial', 'site', 'telefone', 'whatsapp']"></tr>
    <tr mat-row *matRowDef="let row; columns: ['contrato', 'valor', 'data', 'razaoSocial', 'site', 'telefone', 'whatsapp'];"></tr>
  </table>
</div>
